'use client';

import React from 'react';
import styles from './timeline.module.sass';

export interface TimelineItem {
  id?: string;
  title: string;
  description?: string;
  timestamp: string;
  variant?:
    | 'success'
    | 'warning'
    | 'danger'
    | 'info'
    | 'neutral'
    | 'active'
    | 'accent';
  icon?: React.ReactNode;
}

export interface TimelineProps {
  items: TimelineItem[];
  className?: string;
}

export const Timeline: React.FC<TimelineProps> = ({ items, className }) => {
  return (
    <div className={`${styles.timeline} ${className || ''}`}>
      {items.map((item, index) => (
        <div
          key={item.id || index}
          className={`${styles.timelineItem} ${item.variant ? styles[item.variant] : ''}`}
        >
          <div className={styles.timelineDot} />
          <div className={styles.timelineTitle}>{item.title}</div>
          {item.description && (
            <div className={styles.timelineDesc}>{item.description}</div>
          )}
          <div className={styles.timelineMeta}>{item.timestamp}</div>
        </div>
      ))}
    </div>
  );
};

Timeline.displayName = 'Timeline';
